import React from 'react';
import { useQuery } from '@apollo/client/react';
import { GetMimeType } from '@components/core/edit-logo/image-service';
import styles from './style.module.scss';
import { InfoField } from '@components-clean/core/info-field';
import Loading from '@components-clean/core/loading/loading';
import { isEmptyObjectId, isValidObjectId } from '@utils-clean/validation';
import { useTranslation } from '@hooks/index';
import { GET_LOGO_FOR_AUDIT } from '@queries/audit';

type LogoAuditImageProps = {
    logoId: string;
};

const LogoAuditImage = ({ logoId }: LogoAuditImageProps) => {
    const { t } = useTranslation();

    const { data, loading, error } = useQuery(GET_LOGO_FOR_AUDIT, {
        variables: { logoId },
        fetchPolicy: 'cache-first',
    });

    const logoData = data?.getLogoForAudit?.logoData;

    if (loading && logoData == null) {
        return <Loading />;
    }

    if (error != null || logoData == null) {
        return (
            <div className={styles.errorContainer}>
                <InfoField message={t('errorMessage')} type="Error" />
            </div>
        );
    }

    const mimeType = GetMimeType(logoData);
    if (mimeType == null) {
        return (
            <div className={styles.errorContainer}>
                <InfoField message={t('errorMessage')} type="Error" />
            </div>
        );
    }

    return <img src={`data:${mimeType};base64,${logoData}`} alt="Logo" style={{ height: 150, width: 150 }} />;
};

type Props = {
    logoId: string | null | undefined;
};

const LogoAudit = ({ logoId }: Props) => {
    const { t } = useTranslation();

    if (logoId == null || isEmptyObjectId(logoId)) {
        return 'None';
    }

    if (!isValidObjectId(logoId)) {
        return (
            <div className={styles.errorContainer}>
                <InfoField message={t('errorMessage')} type="Error" />
            </div>
        );
    }

    return (
        <>
            <div>{logoId}</div>
            <LogoAuditImage logoId={logoId} />
        </>
    );
};

export default LogoAudit;
